import { render } from "./FullpageProfileTest.vue?vue&type=template&id=1ee4f3b9"
import script from "./FullpageProfileTest.vue?vue&type=script&lang=js"
export * from "./FullpageProfileTest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__